module.exports = {
  year: 2019,
  location: 'YMCA Camp Oakes, Big Bear City, CA',
  from: 'Sat. 06/29/19',
  to: 'Sat. 07/06/19',
  deadline: '05/30/2019',
  refundDeadline: '05/10/2019',
  campFireDate: 'Fri. 07/05/2019',
  ageCheckDate: '2019-06-15',
  price: {
    regular: '$760',
    discount: '$650'
  },
  contact: {
    email: 'summercamp.scccs@gmail.com',
    number: '626.379.9127',
  },
  apiUrl: 'https://yzl52pt2lg.execute-api.us-east-1.amazonaws.com/prod',
  apiKey: 'qFMb58Xzad5jDCiXlGLGL61vZg6E6RJi785pcEVU',
  s3: {
    config: {
      region: 'us-east-1',
      accessKeyId: 'AKIAXVTBTHWPNMOAQLNB',
      secretAccessKey: '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',
    },
    bucket: 'summercamp-enrollments-2019',
  }
}
